// @flow
import { createAction } from "redux-act";

export const setSelectedLeague = createAction("Set Selected Draft League");
export const clearSelectedLeague = createAction("Clear Selected Draft League");


export const setSelectedClassicLeague = createAction("Set Selected Classic League");
export const clearSelectedClassicLeague = createAction("Clear Selected Draft League");